/**
 * Helper function for POSTing data as JSON with fetch.
 *
 * @param {Object} options
 * @param {string} options.url - URL to POST data to
 * @param {FormData} options.formData - `FormData` instance
 * @return {Object} - Response body from URL that was POSTed to
 */

import changeImageUrl from "@/utils/changeImageUrl";
import qs from "qs";
import { unstable_rethrow } from "next/navigation";

const backendApi = process.env.BACKEND_API;

const transformNullToUndefined = (data, depth = 4) => {
  if (data === null) return {};
  for (const key in data) {
    if (data.hasOwnProperty(key) && data[key] === null) {
      data[key] = undefined;
    } else if (typeof data[key] === "object" && depth > 0) {
      transformNullToUndefined(data[key], depth - 1);
    }
  }
  return data;
};

export default async function (contentType, query = "", defaultValues = {}) {
  query = query ? "&" + query : "";
  const populateAll = !query.includes("populate");

  let url = `${backendApi}/${contentType}/?${
    populateAll ? "&populate=*" : ""
  }${query}`;

  const { revalidate = "100" } = qs.parse(query);

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${process.env.STRAPI_TOKEN}`,
      },
      next: {
        revalidate: parseInt(revalidate),
      },
    });
    const result = await response.json();

    await changeImageUrl(result);

    if (result?.data && Array.isArray(result.data))
      return transformNullToUndefined(result);

    return transformNullToUndefined(result?.data ?? defaultValues);
  } catch (error) {
    // Let Next.js internal errors through (e.g. the dynamic-rendering bailout
    // thrown by `revalidate: 0` fetches during prerendering since Next 15).
    unstable_rethrow(error);
    console.log("************************* getData **************************");
    console.log(url);
    console.log(error.message);
    return defaultValues;
  }
};
